<template>
  <modal-base :is-open="isOpen">
    <div
      class="closeLayer"
      @click="emit('cancel')"
    ></div>
    <div class="c-popup-body -middle">
      <div class="c-popup-body__inner">
        <div class="c-popup-body__container">
          <h2 class="c-popup-body__header -border">
            正誤変更
          </h2>
          <div class="c-form-list-wrapper -change">
            <!-- FIXME NFR-7205: 模範解答 -->
            <div class="c-form-list -no-border">
              <div class="c-form-list-title -frame">児童/生徒の解答</div>
              <div class="c-form-list-content -font-bold">
                <student-answer-view
                  :answer="answer"
                  :answer-format="answerFormat"
                  :subject-field="subjectField"
                />
              </div>
            </div>
            <div class="c-form-list -no-border">
              <div class="c-form-list-title -font-normal">変更内容</div>
              <!-- FIXME NFR-7206: 正誤変更対象生徒数 -->
              <div class="c-form-list-content">
                <template v-if="isRevert">
                  各学級の同じ解答をした児童/生徒は、すべて<strong class="u-text-announce">正答</strong>から<strong class="u-text-alert">誤答</strong>に戻されます。
                </template>
                <template v-else>
                  各学級の同じ解答をした児童/生徒は、すべて<strong class="u-text-alert">誤答</strong>から<strong class="u-text-announce">正答</strong>に変更されます。
                </template>
              </div>
            </div>
          </div>
          <p class="c-frame-description u-text-reference -small">
            提出済みの児童/生徒のみが、正誤変更の対象になります。
          </p>
          <p class="c-frame-description u-text-reference -small">
            正誤変更した場合、得点が変更になります。
          </p>
          <p class="c-frame-description u-text-reference -small">
            「データ出力」画面でExcelファイルをダウンロードしている場合は、再度ダウンロードをやり直してください。
          </p>
          <div class="c-button -center -modal">
            <button
              class="c-button-blue -small-no-icon -type02"
              @click="emit('ok')"
            >
              <span class="label">変更する</span>
            </button>
          </div>
        </div>
        <span
          class="c-popup-body__close"
          @click="emit('cancel')"
        >
          <span class="c-popup-body__close-inner"></span>
        </span>
      </div>
    </div>
  </modal-base>
</template>

<script setup lang="ts">
  withDefaults(
    defineProps<{
      isOpen?: boolean;
      isRevert?: boolean;
      answer: string;
      answerFormat: number;
      subjectField?: string;
    }>(),
    {
      isOpen: false,
      isRevert: false,
    }
  )
  const emit = defineEmits<{
    (e: 'ok'): void;
    (e: 'cancel'): void;
  }>()
</script>
